export interface PluralForms {
  one: string;
  few: string;
  many: string;
}

const pluralRules = new Intl.PluralRules('pl');

/** Selects the plural form of a noun for the given count. */
export function pluralize(count: number, forms: PluralForms): string {
  const rule: Intl.LDMLPluralRule = pluralRules.select(count);
  return rule === 'one' || rule === 'few' ? forms[rule] : forms.many;
}
